import { jsx as _jsx } from "react/jsx-runtime";
export const ScheduleOperation = props => {
    const schedule = props.schedule;
    let operation;
    let operation_class;
    if (!schedule.active) {
        operation = 'Inaktiv';
        operation_class = 'operation_inactive';
    }
    else {
        switch (schedule.operation) {
            case 'on':
                operation = 'På';
                operation_class = 'operation_on';
                break;
            case 'off':
                operation = 'Av';
                operation_class = 'operation_off';
                break;
            case 'zigbee on':
                operation = 'På';
                operation_class = 'operation_on';
                break;
            case 'zigbee off':
                operation = 'Av';
                operation_class = 'operation_off';
                break;
            case 'dim':
                operation = 'Dimmer: ' + schedule.dim_level;
                operation_class = 'operation_dim';
                break;
        }
    }
    return (_jsx("div", { className: operation_class, children: operation }));
};
